import React from 'react'
import CategoryNavigationTree from '../../Shop/Components/CategoryNavigationTree'
import { useShop } from '../../../Providers/ShopProvider'
import { MdCategory } from "react-icons/md"
import { useNavigate } from 'react-router-dom'
import { useLastWatchedProducts } from '../../../Providers/LastWatchedProductsProvider'
import CustomSwiper from '../../../Components/Components/CustomSwiper'
import Footer from '../../../Components/Footer'
import useGetConfigFile from '../../../Hooks/useGetConfigFile'

const HomePageAfterSelectCategory = () => {
    const navigate = useNavigate()
    const { activeCategory, setActiveCategory, setShowFeatureListFilter } = useShop()
    const { lastWatchedProducts } = useLastWatchedProducts()

    const handleCategoryClick = (category) => {
        setActiveCategory(category)
        setShowFeatureListFilter(true)
        navigate('/shop')
    }

    if (!activeCategory) {
        navigate('/')
        return null
    }
    return (
        <>
            <div className='container-fluid' style={{ backgroundColor: 'white' }}>
                <div className='row justify-content-center'>
                    <div className='col-11'>
                        <div className='row mt-5 mb-5'>
                            <CategoryNavigationTree />
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-11">
                        <div className="row mb-3">
                            <div className="col-auto">
                                <ImageComponent
                                    path={activeCategory.catFileName}
                                />
                            </div>
                            <div className="col">
                                <b className='ms-2' style={{ fontSize: 30 }}>{activeCategory.catDescription}</b>
                                <span className='ms-2 secondary-color-text' style={{ fontSize: 25 }}>{`(${activeCategory.artCount})`}</span>
                            </div>
                        </div>
                        <div className="row">{activeCategory.catDetailDesc}</div>
                        <div className="row mt-5">
                            {activeCategory.subCategories.map((item, index) => (
                                <div key={index} className={`col-6 col-md-4 col-xl-2 ${index === activeCategory.subCategories.length - 1 ? 'mb-5' : 'mb-2'}`}
                                    style={{ cursor: 'pointer' }} onClick={() => handleCategoryClick(item)}>
                                    <div className="row">
                                        <div className="col-3">
                                            <ImageComponent
                                                path={item.catFileName}
                                            />
                                        </div>
                                        <div className="col d-flex flex-column">
                                            <b>{item.catDescription}</b>
                                            <span className='secondary-color-text'>{item.artCount}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-11">
                    <div className="row mt-5">
                        <CustomSwiper
                            products={[]}
                            header={'Najczęściej zamawiane :'}
                            loop={false}
                            refreshPage={false}
                            autoPlay={false}
                            slidesPerView={5}
                        />
                    </div>
                    <div className="row mt-5">
                        <CustomSwiper
                            products={lastWatchedProducts}
                            header={'Ostatnio oglądane :'}
                            loop={true}
                            refreshPage={false}
                            autoPlay={false}
                            slidesPerView={5}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <Footer />
            </div>
        </>
    )
}

export const ImageComponent = ({ path }) => {
    const { dataUrl } = useGetConfigFile()
    const fullPath = `${dataUrl}/miniaturki/Kategorie/${path}`
    if (path && path.trim() !== '') {
        return <img src={fullPath} style={{ width: '45px', height: '45px', objectFit: 'contain' }} />
    }
    else {
        return null
    }
}

export default HomePageAfterSelectCategory